export const parameterConfig = [
	{
		appname: "biometria",
		parameters:{
			captchaApply: false,
		},
	},
	{
		appname: "biometria_gse",
		parameters:{
			captchaApply: true,
		},
	},
	{
		appname: "biometria_fna",
		parameters:{
			captchaApply: false,
		},
	},
]


export const getComponentConfigValue = (appname, tenant, key) => {
  let paramConfig = null;

  if (tenant !== undefined && tenant !== '') {	
    paramConfig = parameterConfig.filter((x) => x.appname === `${appname}_${tenant}`);
  } else {
    paramConfig = parameterConfig.filter((x) => x.appname === appname);
  }

  let path = null;

  if (paramConfig.length > 0) {
    // Busca el primer objeto válido
    const found = paramConfig.find((object) => object.parameters && object.parameters[key] !== undefined);
	
	if (found) {
      path = found.parameters[key];
    }
  }
	
  return path;
};
